import React, {useEffect} from 'react';
import * as actions from '../actions';

export function FieldAppInspectionOverview() {
	return <div className='dashboard fieldApp'>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span className='icon inspect'>READY FOR INSPECTION <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<table className='interactive' cellPadding='0' cellSpacing='0'>
					<tbody> 
						<tr>
							<td></td>
							<td className='installSheets'>1. Pre-Install Demo</td>
							<td className='right'><a className="button icon iconLabel inspect"><span>INSPECT</span></a></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td className='installSheets'>2. Install, 3. Post Install Glass Inserts</td>
							<td className='right'><a className="button icon iconLabel inspect"><span>INSPECT</span></a></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon job'>JOB <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon specifications'>SPECIFICATIONS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon history'>HISTORY &amp; STATUS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon service'>SERVICE TASKS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon photos'>PHOTOS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				the stuff here
			</div>
		</section>
	</div>;
}